import CONSTANTS from '../CONSTANTS';

const initialState = {
  orders: {},
  orderEdit: {},
  reservedKits: {},
  kitDeleteLoading: false
};

const practiceOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.PRACTICE_ORDER_SET_LIST:
      return { ...state, orders: action.orders };
    case CONSTANTS.PRACTICE_ORDER_SET_EDIT:
      return { ...state, orderEdit: action.order };
    case CONSTANTS.PRACTICE_ORDER_SET_KIT_DELETE_LOADING: 
      return { ...state, kitDeleteLoading: action.value };
    
    case CONSTANTS.PRACTICE_ORDER_SET_RESERVED_KITS: {

      let kits = {};

      if (action.kits.length) {
        for (let kit of action.kits) {
          if (!kits[kit.type]) {
            kits[kit.type] = [];
          }
          kits[kit.type].push(kit);
        }
      }

      return { ...state, reservedKits: kits };
    }

    default:
      return state;
  }
};

export default practiceOrdersReducer;